import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CheckboxFields from 'components/application/CheckboxFields';

export default function CheckboxFilter({
  checkboxes,
  label,
  minChecked = 1,
  onRemove,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <>
      <div className='tw-mb-4 tw-flex tw-items-center tw-justify-between'>
        <label className='tw-m-0 tw-font-medium'>{label}</label>
        <div
          className='tw-flex tw-h-5 tw-cursor-pointer tw-items-center tw-rounded-lg tw-border-0 tw-bg-white tw-px-2 tw-text-grey-500 hover:tw-bg-red-025 hover:tw-text-red-500'
          onClick={onRemove}
        >
          <span className='tw-text-s tw-font-medium tw-tracking-wide'>
            {i18nTShared('removeFilter')}
          </span>
        </div>
      </div>
      <CheckboxFields checkboxes={checkboxes} minChecked={minChecked} />
    </>
  );
}

CheckboxFilter.propTypes = {
  label: PropTypes.string.isRequired,
  checkboxes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.bool,
      onChange: PropTypes.func.isRequired,
    }),
  ),
  minChecked: PropTypes.number,
  onRemove: PropTypes.func.isRequired,
};
